// extracted by mini-css-extract-plugin
module.exports = {"emphasize":"SplitPayoutDialog__emphasize___EH17s"};